const Form068EN = {
    form: "Application for Special Pay Arrangement in the {{schoolYear}} School Year for Over-ranked Head /Stepped-down Teacher(s) at Promotion Rank(s)/ Stepped-down Laboratory Technician I in Aided Secondary or Special Schools",

    errorMsg: {
        "E-0106": "AA000000(A)",
        "E-0105": "Please enter a valid English Name",
        "E-0104": "Please enter a valid Chinese Name",
        "E-0103": "Please input the range of 0-49",
        "E-0102": "Please input the range of 0-49",
        "E-0101": "Please enter the correct number",
        "E-0100": "Please input the range of 14-41",
        "E-0099": "Please input the range of 0-49",
        "E-0107": "Should not be the same rank before/after change",
        "E-0108": "Please select a date between 1 August and 30 September",
        "E-0109": "Should not be the same Incremental Date before/after change",
        "E-0110": "Allow inputs from 0- 49 only",
        "E-0111": "Allow inputs from 0 - 49 only",
        "E-0112": "Allow inputs from 0 - 49 only",
        schoolYear:
            "Please input a valid proposed school year (20XX/XX) which should not be the current school year or earlier",
        firstSchoolYearError:
            "Please input a valid school year (20XX/XX) which should not be the current or subsequent school years",
        reason: "Please input a valid reason",
        firstSchoolYear: "Please input a valid school year",
    },

    stepName: {
        ImportantNotes: "Important Notes",
        action: "Action",
        note: "Note",
        information: "Basic Information",
        payPointForOverRankedStaff: "Pay Point for Over-Ranked Staff",
        certification: "Certification",
        confirmation: "Confirmation",
    },
    businessTypes: {},
    label: {
        ImportantNotesContent: {
            // title: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
            // a: "processing employment-related matters;",
            // b: "processing payment of Salaries Grant and other government funding;",
            // c: "calculation of provident fund contribution;",
            // d: "auditing;",
            // e: "conducting research and compiling statistics to facilitate planning of education services;",
            // f: "processing matters relating to the development of the education profession;",
            // g: "administering and enforcing stipulations under the relevant Code of Aid, Education Ordinance, Education Regulations and the Grant/Subsidized Schools Provident Fund Rules.",
            // title1: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
            // title2: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
            // title3: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
            // title4: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
            title: "Personal Information Collection Statement",
            p_title: "Purpose of Collection",
            p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
            p1_a: "Activities relating to the processing, authentication and counter-checking of the application for special pay arrangement for over-ranked head/ stepped-down teachers or laboratory technicians in aided schools;",
            p1_b: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
            p1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
            p1_d: "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
            p1_e: "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
            p1_f: "Activities relating to compilation of statistics, research and Government publications; and",
            p1_g: "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules) and the Codes of Aid.",

            p2: "The provision of personal data required by this form and during the processing of this form is obligatory. In the event that you do not provide those personal data, we may not be able to handle or further process the application.",

            p_title3: "Classes of Transferees",
            p3_1: "The personal data you provide will be made available to persons working in EDB. Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
            p3_a: "other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
            p3_b: "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
            p3_c: "where you have given your prescribed consent to such disclosure; and",
            p3_d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",

            p_title4: "Access to Personal Data",
            p4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to the respective Senior School Development Officer by post to the Regional Education Office at the address on the EDB website (<a href='https://www.edb.gov.hk/en/contact-us/reo.html' target='_blank'>https://www.edb.gov.hk/en/contact-us/reo.html</a>) or email to <a href='mailto: edbinfo@edb.gov.hk'>edbinfo@edb.gov.hk</a>.",
        },
        conditionCheck:
            "I have read the “Personal Information Collection Statement” and fully understand its content.",
        iamsmart:
            "I understand that an “iAM Smart+” account is required for processing the application.",
        csdoBeforeText: "To :",
        csdoAfterText: ", Education Bureau",
        applicationForm: "Basic Information",
        note: "Note",
        schoolChoice: {
            ManagementCommittee: "School Management Committee",
            Incorporated: "Incorporated Management Committee",
        },

        ActionToBeTakenList: {
            one: "Redeploy the over-ranked staff to fill a vacancy due to retirement / resignation / end of contract of a staff in the same school.",
            two: "Redeploy the over-ranked staff to fill a new post of the corresponding rank to be created in the same  school due to________.",
            three: "Redeploy the over-ranked staff to fill a vacancy due to retirement / resignation / end of contract of a staff in another school under the same sponsoring body.",
            four: "Redeploy the over-ranked staff to fill a new post of the corresponding rank to be created in another school under the same sponsoring body due to________.",
            five: "The over-ranked staff will join job-sharing.",
            six: "The over-ranked staff will retire / resign.",
            seven: "Other action",
            // eight: "Other action",
            // nine: "Other action",
        },
        ActionToBeTakenList1: {
            one: "Redeploy the over-ranked staff to fill a vacancy due to retirement / resignation / end of contract of a staff in the same school.",
            two: "Redeploy the over-ranked staff to fill a new post of the corresponding rank to be created in the same  school due to <u>{{desc}}</u>.",
            three: "Redeploy the over-ranked staff to fill a vacancy due to retirement / resignation / end of contract of a staff in another school under the same sponsoring body.",
            four: "Redeploy the over-ranked staff to fill a new post of the corresponding rank to be created in another school under the same sponsoring body due to <u>{{desc}}</u>.",
            five: "The over-ranked staff will join job-sharing.",
            six: "The over-ranked staff will retire / resign.",
            seven: "Other action: <u>{{desc}}</u>",
            // eight: "Other action: <u>{{desc}}</u>",
            // nine: "Other action: <u>{{desc}}</u>",
        },
        ActionToBeTakenList2: { ten: "NA" },
        IncrementalDateList: {
            none: " ",
            jan: "01",
            feb: "02",
            mar: "03",
            apr: "04",
            may: "05",
            jun: "06",
            jul: "07",
            aug: "08",
            sep: "09",
            oct: "10",
            nov: "11",
            dec: "12",
        },
        conditions:
            "I have read, understand and agree to the above terms and conditions",
        noteList: {
            note1: "1 : Please delete as appropriate.",
            note2: "2 : The stepped-down staff with pay point not reaching the maximum pay point of thestepped-down rank is allowed to proceed along the salary scale of the stepped-down rank.",

            note3: "3 : Excluding the Responsibility Allowance, if any.",
            note4:
                "4 : For stepping down that involves a teacher at more than one rank above the basic rank (e.g. PGM) and where no vacancy is available at the next lower rank, the school concerned is given the discretion to decide whether to have" +
                "the teacher step down more than one rank or to have a series of step-downs involving more than one teacher until " +
                "the entitlement is not exceeded. The decision made should be supported with strong justifications. An appeal " +
                "mechanism should also be in place. All these should be made known to the teachers of the school and be properly" +
                "documented as a safeguard against any allegations of unfairness or impropriety that may subsequently arise.",
            note5: "5 : No longer eligible for any Responsibility Allowance previously entitled to, if any, which thus should be excluded.",
            note6: '6 : Only applicable to the stepped-down staff with pay point not yet exceeding the maximum pay point of the stepped-down rank. For all other cases, please indicate "NA" as the stepped down staff will not be granted any salary increment until he/she <b>is reinstated to the previous rank at your school</> for normal progression along the salary scale of the previous rank.',
            note7: "7 : Please refer to the attached Annex and fill in the Code Number.",
            note8: "8 : If the proposed school year is not the 2022/23 school year, the school should also attach a plan on how to rectify the situation and list out the anticipated vacancy situation of promotion ranks among schools under the same sponsoring body (if applicable) in the coming school years.",

            note0: "I confirm that:",
            notea: "(a) the selection arrangement of surplus staff stipulated in EDBCM No. 45/2021 has been observed;",
            noteb:
                "(b) there are no vacancies of the relevant ranks within schools under the same" +
                "sponsoring body for redeployment in the 2021/22 school year. The vacancy situation of respective" +
                "promotion ranks within the school and among schools under the same sponsoring body (if  " +
                "applicable) is attached;",
            notec: "(c) the stepped-down staff were informed of the above special and temporary arrangement;",
            noted: "(d) the particulars in this form including the Rectification Plan are correct;",
            notee: "(e) the duties of the stepped-down staff will be commensurate with his/her/their salary as far as possible in the 2021/22 school year; and",
            notef: "(f) the School shall refund any overpaid salaries grant to the Education Bureau.",
        },
        rankList: {
            LTIII: "LTIII",
            LTII: "LTII",
            LTI: "LTI",
            CM: "CM",
            AM: "AM",
            SAM: "SAM",
            PAM: "PAM",
            GM: "GM",
            SGM: "SGM",
            PGM: "PGM",
            PII: "PII",
            PI: "PI",
        },
    },
    information: {
        CSDO: "CSDO",
        schoolName: "Name of School",
        schoolCode: "School Code",
        Date: "Date",
        ManagementCommittee:
            "The School Management Committee/Incorporated Management Committee",
        formHeaderTitle: "Staff {{index}}",
        code: "Code",
        HKIDNo: "HKID No.",
        EnglishName: "English Name",
        ChineseName: "Chinese Name",
        pleaseSpecify: "Please Specify",
        firstSchoolYear:
            "For staff who stepped down on or before 31 August {{year}}, fill in the school year of the approval of the <u><b>1<sup>st</sup> application</b> of special pay arrangement</u>",
        Ranks: "Rank",
        Salary: "Salary (MPS Pt)",
        //SalaryBar: "Salary Bar (MPS Pt)",
        MaxSalary: "Max Salary (MPS Pt)",
        IncrementalDate: "Incremental Date (01/mm)",
        EffectiveDateFrom: "Effective Date From",
        EffectiveDateTo: "Effective Date To",

        Rank: "Rank",
        Salary3: "Salary (MPS Pt)",
        //SalaryBars: "Salary Bar (MPS Pt)",
        MaxSalarys: "Max Salary (MPS Pt)",
        IncrementalDates: "Incremental Date (01/mm)",
        DateOfNextIncrement: "Date of Next Increment",
        // ActionToBeTaken: "Action to be Taken",
        // ActionToBeTaken:"Action To be Taken in the {{schoolyear}} School Year and the Years Afterwards",
        ActionToBeTaken:
            "Action to be taken in the {{schoolYearNext}} school year",
        ProposedSchoolYear:
            "If the situation cannot be rectified in the {{schoolYearNext}} school year, please specify the school year in which the situation is expected to be rectified",
        // ProposedSchoolYear: "Proposed School Year",

        attachment: "Supplementary document",
        formConfirm: "I confirm that:",
        attachment1: "Attachment",
        Notes1: "As at 31 August {{year}}",
        EffectiveDateFromBeforeText: "From ",
        EffectiveDateFromAfterText: " to",
        EffectiveDateToAfterText:
            "upon Stepping Down (Please Amend the Period if Necessary).",
        // Notes2: "Effective from {{from}} to {{to}} upon Stepping Down (Please Amend the Period if Necessary) ",
        Notes2: "From {{from}} to {{to}}",
        Notes4: "Effective  upon Stepping Down",
        Notes3: "Rectification Plan",
        // Notes3: "Plan to Rectify the Over-ranked Situation",

        beforeDateText: "I refer to your letter dated",
        afterDateText: ". The",
        beforeNote1Text:
            "would like to seek approval for the following over-ranked staff (including those over-ranked head, stepped-down teacher(s) at promotion rank(s) and/or stepped-down laboratory technician I who stepped down prior to 1 September {{year}} ) to retain, in the {{schoolyear}} school year, ",
        afterNote1Text: " pay point(s) as at",
        noteLabel1: " his/her/their ",
        noteLabel2: " 31 August {{year}}",
        afterNote2Text: " as detailed below -",
    },
    monthOptions: {
        aug: "August",
        sept: "September",
    },
    SalaryList: {
        25: "51,095",
        26: "53,500",
        27: "55,995",
        28: "58,635",
        29: "61,415",
        30: "64,270",
        31: "67,295",
        32: "70,465",
        33: "73,775",
        34: "74,515",
        35: "75,265",
        36: "78,385",
        37: "82,105",
        38: "85,870",
        39: "89,845",
        40: "93,710",
        41: "97,745",
    },
    CSDOValue: {
        0: "Central & Western District",
        1: "Southern District",
        2: "Wan Chai District",
        3: "Islands District",
        4: "Hong Kong East District",
        5: "Kowloon City District",
        6: "Sham Shui Po District",
        7: "Sai Kung District",
        8: "Kwun Tong District",
        9: "Wong Tai Sin District",
        10: "Yau Tsim & Mong Kok District",
        11: "Tai Po District",
        12: "North District",
        13: "Sha Tin District",
        14: "Kwai Chung & Tsing Yi District",
        15: "Tsuen Wan District",
        16: "Tuen Mun District",
        17: "Yuen Long District",
    },
    notes: {
        a: "the selection arrangement of surplus staff stipulated in {{circularNumber}} has been observed;",
        b: "there are no vacancies of the relevant ranks within schools under the same sponsoring body for redeployment in the {{schoolyear}} school year. The vacancy situation of respective promotion ranks within the school and among schools under the same sponsoring body (if applicable) is attached;",
        c: "the stepped-down staff were informed of the above <b>special and temporary</b> arrangement;",
        d: "the particulars in this form including the Rectification Plan are correct;",
        e: "the duties of the stepped-down staff will be commensurate with his/her/their salary as far as possible in the {{schoolyear}} school year; and",
        f: "the School shall refund any overpaid salaries grant to the Education Bureau.",
    },
    // confirmStatementList: {
    //     a: "the selection arrangement of surplus staff stipulated in EDBCM {{circularNumber}} has been observed;",
    //     b: "there are no vacancies of the relevant ranks within the school or in schools under the same sponsoring body for redeployment in the {{schoolYear}} school year. The vacancy situation of respective promotion ranks within the school and among schools under the same sponsoring body (if applicable) is attached;",
    // },
    // confirmStatementList2: {
    //     c: "the stepped-down staff were informed of the above ",
    //     cBoldAUnderlineText: " special and temporary ",
    //     cAfterBoldAUnderlineText: "arrangement;",
    // },

    // confirmStatementList3: {
    //     d: "the particulars in this form including the Rectification Plan are correct;",
    //     e: "the duties of the stepped-down staff will be commensurate with his/her/their salary as far as possible in the {{schoolYear}} school year; and",
    //     f: "the School shall refund any overpaid salaries grant to the Education Bureau.",
    // },
    // statement1:
    //     "(a) The selection arrangement of surplus staff stipulated in EDBCM No. 46/2020 has been observed;",
    // statement2:
    //     "(b) There are no vacancies of the relevant ranks within the school or in schools under the same sponsoring body for redeployment in the 2020/21 school year. The vacancy situation of respective promotion ranks within the school and among schools under the same sponsoring body (if applicable) is attached;",
    // statement3: "(c) The stepped-down staff were informed of the above ",
    // statement3BoldAUnderlineText: "special and temporary ",
    // statement3AfterBoldAUnderlineText: "arrangement;",
    // statement4:
    //     "(d) The particulars in this form including the Rectification Plan are correct;",
    // statement5:
    //     "(e) Duties of the stepped-down staff will be commensurate with his/her/their salary as far as possible in the 2020/21 school year; and",
    // statement6:
    //     "(f) The School shall refund to the Education Bureau any over-payment of the salaries grant paid to it.",

    tooltipList: {
        tooltip1: "Please delete as appropriate.",
        tooltip2:
            "The stepped-down staff with pay point not reaching the maximum pay point of the stepped-down rank is allowed to proceed along the salary scale of the stepped-down rank.",
        tooltip3:
            "Only applicable to the stepped-down staff who have been approved for special pay arrangement before. Please indicate “NA” for staff who has stepped down with effect from 1 September {{year}} and submits the first application for special pay arrangement in the {{schoolyear}} school year.",
        tooltip4: "Excluding the Responsibility Allowance, if any.",
        tooltip5:
            "For stepping down that involves a teacher at <u>more than one rank</u> above the basic rank (e.g. PGM) and where no vacancy is available at the next lower rank, the school concerned is given the discretion to decide whether to have the teacher step down more than one rank or to have a series of step-downs involving more than one teacher until the entitlement is not exceeded. The decision made should be supported with strong justifications. An appeal mechanism should also be in place. All these should be made known to the teachers of the school and be properly documented as a safeguard against any allegations of unfairness or impropriety that may subsequently arise.",
        tooltip6:
            "No longer eligible for any Responsibility Allowance previously entitled to, if any, which thus should be excluded.",
        tooltip7:
            'Only applicable to the stepped-down staff with pay point not yet exceeding the maximum pay point of the stepped-down rank. For all other cases, please indicate "NA" as the stepped-down staff will not be granted any salary increment until he/she <b>is reinstated to the previous rank at your school</b> for normal progression along the salary scale of the previous rank.',
        tooltip8:
            "(Please indicate “NA” if the school year in which the over-ranked situation is expected to be rectified is not the {{schoolYearNext}} school year.)",
        tooltip9:
            "(If the school year in which the over-ranked situation is expected to be rectified is not the {{schoolYearNext}} school year, the school should also attach a plan on how to rectify the over-ranked situation and list the anticipated vacancy situation of promotion ranks among schools under the same sponsoring body (if applicable) in the coming school years.)",
        tooltip10: "The Max Salary should not be smaller than the Salary",
        tooltip11: "Proposed school year should not be a previous school year",
    },
};
export default Form068EN;
